import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { useUnselectCheckboxConfirmation } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/GrubhubSeamlessPlusControl/hooks/useUnselectCheckboxConfirmation';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';
import { OrderingPolicyDeactivationModal } from './OrderingPolicyDeactivationModal';

export interface OrderingPolicyControlProps {
  name: string;
  id: string;
  isDisabled: boolean;
}

export function OrderingPolicyControl({
  name,
  id,
  isDisabled,
}: OrderingPolicyControlProps): JSX.Element {
  const { control } = useFormContext();
  const {
    confirmationModalOpen,
    setFieldValue,
    onChangeCheckedFeature,
    closeConfirmationModal,
  } = useUnselectCheckboxConfirmation(name);
  const tooltipText = (
    <ul>
      <li>
        An ordering policy provides a formal way to ensure employees agree to
        specific policies when placing an order
      </li>
      <li>
        Admins can enable the ordering policy requirement for individual
        ordering permissions
      </li>
      <li>
        Deactivating will remove the ordering policy requirement for all
        ordering permissions
      </li>
      <li>
        Copy and directly use the value in the Contentful system for the slug
        field
      </li>
    </ul>
  );

  return (
    <>
      <CookbookCheckboxWrapper
        control={control}
        id={id}
        name={name}
        disabled={isDisabled}
        onChange={onChangeCheckedFeature}
        label={
          <CustomLabelWithTooltip
            color="primaryText"
            labelText="Ordering policy"
            tooltipInfo={
              <Copy variant="body" color="invertedPrimaryText">
                {tooltipText}
              </Copy>
            }
          />
        }
      />
      {confirmationModalOpen && (
        <OrderingPolicyDeactivationModal
          onConfirm={setFieldValue}
          onClose={closeConfirmationModal}
        />
      )}
    </>
  );
}
